module.exports = __webpack_public_path__ + "static/media/delete.e5e695eb.svg";